import { Chip } from "@mui/material"

export function TaskReadOnlyTagChip({ item }) {
    return <Chip size="small" variant="outlined" label={item} />
}
